import { useRef } from "react";
import { motion } from "framer-motion";

export default function MagneticButton({ children, className = "", strength = 0.35, onClick, as: As = "button", to, href, ...rest }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  };
  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = `translate(0px, 0px)`;
  };

  return (
    <As
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      onClick={onClick}
      to={to}
      href={href}
      data-magnetic="true"
      className={`inline-flex items-center justify-center transition-transform duration-300 ease-out will-change-transform ${className}`}
      {...rest}
    >
      <motion.span initial={false} className="inline-flex items-center justify-center">
        {children}
      </motion.span>
    </As>
  );
}
